// extracted by mini-css-extract-plugin
module.exports = {"copylink_btn":"Content_copylink_btn__rqbdL"};